
import { LuSearch } from "@/Components/Icons/Icons.jsx";
export default {
  row1:[
  {
    column: "column1",
    columnWidth: "50%",
    rows: {
      row1: [
        {
          name: "exportShipmentInvoiceBuyersOrderNo",
          label: "Buyers Order No",
          component: "text-field",
          width: "50%",

        },

        {
          name: "exportShipmentInvoiceBuyersOrderNoDate",
          component: "dateselector",
          width: "50%",
          disabled: true,
          dependsOn:"exportShipmentInvoiceBuyersOrderNo"
        },
      ],
      row2: [
        {
          name: "exportShipmetInvoiceOtherReferences",
          label: "Others References",
          component: "text-field",
        },
      ],
      row3: [
        {
          name: "exportShipmentInvoiceTermsOfDeliveryAndPAyment",
          actionText: "Terms of Delivery and Payment",
          component: "TextArea",
          height: "120px",
        },
      ],
      row4: [
        {
          name: "exportShipmetInvoiceOriginCountry",
          label: "Origin Country",
          component: "text-field",
          icon: LuSearch,
          iconColor: "gray-400",
          type: "autocomplete",
          endpoint: "getCountry",
        },
      ],
      row5: [
        {
          name: "exportShipmentInvoiceHeader",
          label: "Invoice Header",
          component: "text-field",
        },
      ],
    },
  },
]
};

